import React from 'react'
import { Checkbox } from 'antd'
import styled from 'styled-components'
import { CompanyListDiv } from '../../../style'

const PriorityLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
`

const ColorCircle = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.color};
`

const PriorityFilter = ({
  handlePriorityCheckboxChange,
  selectedPriorities,
  prioritiesData,
}) => {
  return (
    <CompanyListDiv style={{ marginTop: '10%' }}>
      {prioritiesData.map(({ label, color, value }) => (
        <Checkbox
          style={{ margin: '0px' }}
          key={value}
          onChange={() => handlePriorityCheckboxChange(value)}
          checked={selectedPriorities?.includes(value)}
        >
          <PriorityLabel>
            <ColorCircle color={color} />
            {label}
          </PriorityLabel>
        </Checkbox>
      ))}
    </CompanyListDiv>
  )
}

export default PriorityFilter
